import React from 'react';
import StarIcon from '../assets/images/icons/start-icon.svg';
import SongIcon from '../assets/images/icons/song-recommend.svg';

const DummyChart = ({
    icon = null,
    chartType = 'area',
    topText = '0',
    bottomText = 'Data',
    onProClick = () => { },
    showCta = true,
    ctaLabel = 'Go Pro',
    showCtaIcon = true,
    compactCta = false,
    variant = 'default',
    chartHeight = 180,
}) => {
    const isMetricCard = variant === 'metricCard';

    const renderDummyChart = () => {
        const chartClass = isMetricCard
            ? 'w-full opacity-70'
            : 'w-full h-32 opacity-70';

        switch (chartType) {
            case 'area':
                if (isMetricCard) {
                    return (
                        <div className="aspect-square w-full opacity-70">
                            <svg
                                className="h-full w-full"
                                viewBox="0 0 200 60"
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <defs>
                                    <linearGradient id="areaGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                        <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.4" />
                                        <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.1" />
                                    </linearGradient>
                                </defs>
                                <path
                                    d="M0,50 L20,45 L40,38 L60,42 L80,30 L100,35 L120,25 L140,28 L160,20 L180,22 L200,15 L200,60 L0,60 Z"
                                    fill="url(#areaGradient)"
                                />
                                <path
                                    d="M0,50 L20,45 L40,38 L60,42 L80,30 L100,35 L120,25 L140,28 L160,20 L180,22 L200,15"
                                    fill="none"
                                    stroke="#3b82f6"
                                    strokeWidth="2"
                                />
                            </svg>
                        </div>
                    );
                }
                return (
                    <svg className={chartClass} viewBox="0 0 200 60">
                        <defs>
                            <linearGradient id="areaGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.4" />
                                <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.1" />
                            </linearGradient>
                        </defs>
                        <path
                            d="M0,50 L20,45 L40,38 L60,42 L80,30 L100,35 L120,25 L140,28 L160,20 L180,22 L200,15 L200,60 L0,60 Z"
                            fill="url(#areaGradient)"
                        />
                        <path
                            d="M0,50 L20,45 L40,38 L60,42 L80,30 L100,35 L120,25 L140,28 L160,20 L180,22 L200,15"
                            fill="none"
                            stroke="#3b82f6"
                            strokeWidth="2"
                        />
                    </svg>
                );
            case 'image':
                return (
                    <div
                        className={`flex items-center justify-around gap-1 bg-gray-500 px-2 ${
                            isMetricCard ? 'aspect-square w-full' : ''
                        }`}
                        style={isMetricCard ? undefined : { height: 128 }}
                    >
                        <img src={SongIcon} className="h-16 w-16" alt="" />
                    </div>
                );
            default:
                return (
                    <svg className={chartClass} viewBox="0 0 200 60">
                        <defs>
                            <linearGradient id="areaGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" stopColor="#3b82f6" stopOpacity="0.4" />
                                <stop offset="100%" stopColor="#3b82f6" stopOpacity="0.1" />
                            </linearGradient>
                        </defs>
                        <path
                            d="M0,50 L20,45 L40,38 L60,42 L80,30 L100,35 L120,25 L140,28 L160,20 L180,22 L200,15 L200,60 L0,60 Z"
                            fill="url(#areaGradient)"
                        />
                        <path
                            d="M0,50 L20,45 L40,38 L60,42 L80,30 L100,35 L120,25 L140,28 L160,20 L180,22 L200,15"
                            fill="none"
                            stroke="#3b82f6"
                            strokeWidth="2"
                        />
                    </svg>
                );
        }
    };

    const rootClass = isMetricCard
        ? 'relative flex h-full w-full min-h-0 flex-col justify-between gap-2 overflow-hidden'
        : 'relative h-full min-h-[150px] w-full overflow-hidden rounded-lg bg-white';

    const contentClass = isMetricCard
        ? 'relative z-0 flex h-full flex-col justify-between gap-2'
        : 'relative z-0 flex h-full flex-col p-4';

    const iconWrapClass = chartType === 'image' && isMetricCard ? 'icon' : 'icon mb-1';
    const chartWrapClass = isMetricCard ? 'chart-wrapper flex-1' : 'flex-1 -mx-2';
    const chartWrapStyle =
        isMetricCard && chartType !== 'image' ? { marginLeft: '-10px' } : undefined;

    return (
        <div className={rootClass}>
            <div className={contentClass}>
                {icon && (
                    <div className={isMetricCard ? iconWrapClass : 'mb-1'}>
                        {typeof icon === 'string' ? (
                            <img src={icon} alt="Icon" className="w-6 h-6" />
                        ) : (
                            icon
                        )}
                    </div>
                )}

                <div className={chartWrapClass} style={chartWrapStyle}>
                    {renderDummyChart()}
                </div>

                <div className={isMetricCard ? 'cover relative z-30' : 'relative z-30 mt-2'}>
                    <div className="mb-0.5 text-xs font-bold text-gray-800">{topText}</div>
                    <div className="text-xs font-medium text-theme_clr1">{bottomText}</div>
                </div>
            </div>

            <div className="pointer-events-none absolute inset-0 z-10 bg-gray-200/5 backdrop-blur-[1px]" />

            {showCta && (
                <div className="absolute inset-0 z-20 flex items-center justify-center pb-8">
                    <button
                        type="button"
                        className={`btn-custom3 flex items-center shadow-md ${
                            compactCta ? 'gap-1.5 !px-4 !py-2 !text-sm' : 'gap-2'
                        }`}
                        onClick={onProClick}
                    >
                        {ctaLabel}
                        {showCtaIcon && (
                            <img
                                src={StarIcon}
                                alt=""
                                className={
                                    compactCta
                                        ? 'h-[16px] w-[16px] min-w-[16px]'
                                        : 'h-[20px] w-[20px] min-w-[20px]'
                                }
                            />
                        )}
                    </button>
                </div>
            )}
        </div>
    );
};

export default DummyChart;
